import { DynamicIcon, Tooltip } from 'src/components';

export const IconCell = ({ icon, label }: { icon: string; label?: string }) => {
  if (!label) {
    return <DynamicIcon name={icon} />;
  }

  return (
    <Tooltip title={label}>
      <DynamicIcon name={icon} />
    </Tooltip>
  );
};
